import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { TaxForm1099 } from '@truckerally/data-types';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { previewBinaryInBrowser } from '../utils/media.helper';

@Injectable({
  providedIn: 'root'
})
export class PayrollService {
  constructor(
    private http: HttpClient,
    private zone: NgZone,
  ) { }

  viewTaxDocument(id: string) {
    return this.http.get(`${environment.api.carrier}v1/payroll/filings/document/${id}`, { responseType: 'arraybuffer' }).pipe(
      previewBinaryInBrowser('pdf')
    )
  }

  createContractor(body: any) {
    return this.http.post(`${environment.api.carrier}v1/payroll/contractors`, body);
  }

  getContractorPayments(contractorId: any) {
    return this.http.get(`${environment.api.carrier}v1/payroll/payments`, { params: { contractor: contractorId } });
  }

  getContractorFilings(contractorId: any) {
    return this.http.get(`${environment.api.carrier}v1/payroll/filings/contractor/${contractorId}`);
  }

  addPayment(body: any) {
    return this.http.post(`${environment.api.carrier}v1/payroll/payments`, body);
  }

  updatePayment(id: string, body: any) {
    return this.http.patch(`${environment.api.carrier}v1/payroll/payments/${id}`, body);
  }

  getRelatedPayments(id: string) {
    return this.http.get(`${environment.api.carrier}v1/payroll/payments/${id}/similar`);
  }

  /**
   * 
   * @param body 
   * @param filing - Existing filing
   * @returns 
   */
  preview1099Forms(body: TaxForm1099.PreviewFormRequest, filing?: any) {
    return this.http.post(`${environment.api.carrier}v1/payroll/forms/preview/1099`, body, {
      responseType: 'arraybuffer', headers: {
        'x-filing-id': filing?.id || ''
      }
    })
  }

  prepare1099Forms(body: TaxForm1099.SubmitFormRequest, filing?: any) {
    return this.http.post(`${environment.api.carrier}v1/payroll/forms/prepare/1099`, body, {
      headers: {
        'x-filing-id': filing?.id || ''
      }
    });
  }

  getFilingUpdates(id: string) {
    return new Observable((observer) => {
      const source = new EventSource(`${environment.api.carrier}v1/payroll/filings/${id}/updates`);

      source.onmessage = event => {
        this.zone.run(() => {
          observer.next(JSON.parse(event.data))
        })
      }

      source.onerror = event => {
        this.zone.run(() => {
          observer.error(event)
        })
      }

      return {
        unsubscribe: () => {
          source.close();
        }
      }

    });
  }

  getFilings(): Observable<any> {
    return this.http.get(`${environment.api.carrier}v1/payroll/filings`);
  }

  getFilingDetails(id: string): Observable<any> {
    return this.http.get(`${environment.api.carrier}v1/payroll/filings/${id}`);
  }

  getSubmissionDetails(id: string): Observable<any> {
    return this.http.get(`${environment.api.carrier}v1/payroll/filings/${id}/submission`);
  }

  getContractors() {
    return this.http.get<any[]>(`${environment.api.carrier}v1/payroll/contractors`)
  }

  getSettings() {
    return this.http.get<any[]>(`${environment.api.carrier}v1/payroll/settings`)
  }

  updateContractorPayroll(config: any) {
    return this.http.put(`${environment.api.carrier}v1/payroll/settings/contractor`, config);
  }

  updateContractor(id: string, info: any) {
    return this.http.patch(`${environment.api.carrier}v1/payroll/contractors/${id}`, info);
  }

  deleteContractore(id: string) {
    return this.http.delete(`${environment.api.carrier}v1/payroll/contractors/${id}`);
  }

  updateContractorInfo(id: string, info: any) {
    return this.http.put(`${environment.api.carrier}v1/payroll/contractors/${id}`, info);
  }


  getContractor(id: string) {
    return this.http.get<any>(`${environment.api.carrier}v1/payroll/contractors/${id}`);
  }

  getCompanyInfo() {
    return this.http.get(`${environment.api.carrier}v1/payroll/company`);
  }


}

